import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Column, Columns } from '../components/base/grid';
import { RawLoader } from '../components/loading/loading';
import Login from '../components/myPost/loginComponent';
import Menu from '../components/myPost/menu';
import Onboarding from '../components/myPost/onboarding';
import media from '../constants/media';
import IUserProfileReducer from '../interfaces/reducers/userProfileReducer';
import { IStore } from '../reducers';

export const Wrapper = styled.div`
	margin: 5rem 0rem;

	${media.mobileAndTabletOnly`
		margin: 10rem 0rem;
	`}

	${media.desktopHuge`
		margin: 5rem 10rem;
	`}
`;

const myPostWrapper =
	Component =>
	({ page, ...restProps }) => {
		const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
			store => store.userProfileReducer
		);
		const { userProfile, userLoading, isLoggedIn } = userProfileReducer;

		return (
			<>
				{!userLoading && !isLoggedIn && <Login page={page} />}
				{!userLoading && isLoggedIn && !userProfile.hasAgreedToGdprTerms && <Onboarding />}

				{!userLoading && isLoggedIn && userProfile.hasAgreedToGdprTerms && (
					<Wrapper>
						<Columns>
							<Column desktopSmall={1 / 5}>
								<Menu page={page} />
							</Column>
							<Column desktopSmall={4 / 5}>
								<Component {...restProps} page={page} />
							</Column>
						</Columns>
					</Wrapper>
				)}
				{userLoading && <RawLoader />}
			</>
		);
	};

export default myPostWrapper;
